import { VStack } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import Face from './Face';

function FacesCheck({ checked, faces, onCheck }) {
  return (
    <VStack>
      {faces.map((face) => (
        <Face
          key={face.index}
          checked={checked[face.index]}
          face={face.face}
          onCheck={() => onCheck(face.index)}
        />
      ))}
    </VStack>
  );
}

FacesCheck.propTypes = {
  checked: PropTypes.array.isRequired,
  faces: PropTypes.array.isRequired,
  onCheck: PropTypes.func.isRequired,
};

export default FacesCheck;
